// extracted by mini-css-extract-plugin
export default {"add":"add___b8aa7796b88739635f5a","btn":"btn___baef0a998b9e14fccca0"};